// Test IDs for the GeoBeats marketing landing page.

export const LANDING = {
  navLogo: 'landing-nav-logo',
  navFeaturesLink: 'landing-nav-features-link',
  navHowItWorksLink: 'landing-nav-how-it-works-link',
  navSupportLink: 'landing-nav-support-link',
  navCtaButton: 'landing-nav-cta-button',
  heroTitle: 'landing-hero-title',
  heroSubtitle: 'landing-hero-subtitle',
  heroCtaPrimary: 'landing-hero-cta-primary',
  heroCtaSecondary: 'landing-hero-cta-secondary',
  heroPhoneMockup: 'landing-hero-phone-mockup',
  marquee: 'landing-marquee',
  featuresHeading: 'landing-features-heading',
  featureRow: (i) => `landing-feature-row-${i}`,
  howItWorksHeading: 'landing-how-it-works-heading',
  howItWorksStep: (i) => `landing-how-it-works-step-${i}`,
  waitlistHeading: 'landing-waitlist-heading',
  waitlistForm: 'landing-waitlist-form',
  waitlistEmailInput: 'landing-waitlist-email-input',
  waitlistSubmitButton: 'landing-waitlist-submit-button',
  footerPrivacyLink: 'landing-footer-privacy-link',
  footerSupportLink: 'landing-footer-support-link',
  footerLogo: 'landing-footer-logo',
};
